import type { SVGComponentProps } from 'BreetHelpers';

export const BreadcrumbAngleIcon = ({ ...rest }: SVGComponentProps) => (
	<svg
		width='10'
		height='18'
		viewBox='0 0 10 18'
		fill='none'
		xmlns='http://www.w3.org/2000/svg'
		data-testid='breadcrumb-angle-icon'
		{...rest}
	>
		<path
			fillRule='evenodd'
			clipRule='evenodd'
			d='M0.71967 9.72174C0.426777 9.42884 0.426777 8.95397 0.71967 8.66108L8.21967 1.16108C8.51256 0.868183 8.98744 0.868183 9.28033 1.16108C9.57322 1.45397 9.57322 1.92884 9.28033 2.22174L2.31066 9.19141L9.28033 16.1611C9.57322 16.454 9.57322 16.9288 9.28033 17.2217C8.98744 17.5146 8.51256 17.5146 8.21967 17.2217L0.71967 9.72174Z'
			fill='#17181C'
		/>
	</svg>
);
